export enum NOTIFICATION_STATUS_CODE {
    DISP = 'DISP',
    ETA = 'ETA',
    DURA = 'DURA',
    REMT = 'REMT',
    ROSR = 'ROSR',
    FCC = 'FCC',
    TRAV = 'TRAV',
    OSR = 'OSR',
    SOSR = 'SOSR', // SOSR: Special OSR for PACE US
    CRM = 'CRM',
    SCRM = 'SCRM',
    AVR1 = 'AVR1',
    AVR2 = 'AVR2',
    AVRF = 'AVRF',
    CANC = 'CANC',
    BREK = 'BREK',
    WAIT = 'WAIT',
    // This is an internal statusCode to indicate that the notification is ready to be signed.
    // It implies that a different notification can be put to TRAV and higher
    TOBS = 'TOBS',
    // for handling whats new status sms
    ADA = 'ADA',
    REFR = 'REFR',
    // new internal status to track if user has acknowledge
    CNCL = 'CNCL',
    // Need RTOBS If Remote Work/Training(ROSR) to be signed,
    // Need FTOBS If Remote Support(FCC) to be signed,
    // RTOBS and FTOBS: Remote work/ Remote support to be signed, this is an internal statusCode to indicate that selected is Remote work status and is ready to be signed.
    // Used in time recording work type dropdown is filtered based on ROSR or FCC
    RTOBS = 'RTOBS',
    FTOBS = 'FTOBS',
    ATS = 'ATS', // Safety Assessment Form
}

export enum STATUS_STEP_FOR_REMOTE_WORK {
    DISP = 'DISP',
    ETA = 'ETA',
    REMT = 'REMT',
    ROSR = 'ROSR',
    FCC = 'FCC',
    SCRM = 'SCRM',
    CRM = 'CRM',
    ESCALATE = 'ESCALATE',
    FORMS = 'FORMS',
    TRAV = 'TRAV',
    OSR = 'OSR',
}
export enum STATUS_STEP_FOR_NON_REMOTE_WORK {
    DISP = 'DISP',
    ETA = 'ETA',
    TRAV = 'TRAV',
    ATS = 'ATS',
    OSR = 'OSR',
    SCRM = 'SCRM',
    CRM = 'CRM',
    ESCALATE = 'ESCALATE',
    FORMS = 'FORMS',
    ROSR = 'ROSR',
    FCC = 'FCC',
}

/**
 * codes a confirmation may actually be filled in from: on site (OSR/SOSR), remote
 * work in progress (ROSR/FCC), or already filled in and waiting on the signature
 * (TOBS/RTOBS/FTOBS).
 *
 * Deliberately narrower than "in progress": TRAV means still travelling there, with nothing on
 * site yet to confirm.
 *
 * The one place this rule is defined — `StatusModel.isConfirmable` and the notification
 * selectors' `selectNotificationConfirmableByNotification` both read it, so the confirmation
 * route's can-activate guard and the timesheet's row links can't drift apart on what counts as
 * confirmable. Lives next to the enum, rather than on `StatusModel` or in the selector file, so
 * both can import it without either depending on the other.
 *
 * @param code
 */
export const CONFIRMABLE_STATUS_CODES = new Set<string>([
    NOTIFICATION_STATUS_CODE.OSR,
    NOTIFICATION_STATUS_CODE.SOSR,
    NOTIFICATION_STATUS_CODE.ROSR,
    NOTIFICATION_STATUS_CODE.FCC,
    NOTIFICATION_STATUS_CODE.TOBS,
    NOTIFICATION_STATUS_CODE.RTOBS,
    NOTIFICATION_STATUS_CODE.FTOBS,
]);
